/* eslint-disable graphql/template-strings */
import gql from 'graphql-tag';

const GET_ALERT = gql`
  query getAlert($alertId: String!) {
    me {
      alert(id: $alertId) {
        id
        title
        body
        image {
          src
          alt
        }
        confirmLabel
        confirmUrl
        dismissLabel
      }
    }
  }
`;

export default GET_ALERT;
